import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/unlock.vue
var s = {
	name: "DtIconUnlock",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--unlock"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Unlock",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M7.187 1.887A2 2 0 0 0 4 3.5V5h5.5A1.5 1.5 0 0 1 11 6.5V10a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 10V6.5A1.5 1.5 0 0 1 2.5 5H3V3.5a3 3 0 0 1 5.94-.6.5.5 0 1 1-.98.2 2 2 0 0 0-.773-1.213ZM2 6.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5V10a.5.5 0 0 1-.5.5h-7A.5.5 0 0 1 2 10V6.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=unlock.js.map